import { Application, ColumnMetadata, ConditionAttributeMappingModel, EnumMcpUserModelEnforcementMode, McpServerDiscoveryModel, McpUserModel } from "@/api";
import { type ConditionBuilderConfig } from "@/components/ConditionBuilder";

export const mcpUser: McpUserModel = {
    "enforcementMode": EnumMcpUserModelEnforcementMode.PROXY,
    "credentials": {
        "tokenEndpoint": "https://integrator-9631883.okta.com/oauth2/default/v1/token",
        "clientId": "0oa10h6kyzdfjOBPi698",
        "clientSecret": "*****",
        "scope": "default",
        "urlHost": "https://trustlogix.io/mcp"
    }
}

export const mcpServers: Application[] = ([
  {
    "id": "ff8080819cbbd623019cbbd6e2720002",
    "name": "Snowflake MCP Server",
    "description": "Snowflake Managed MCP Server with Multi-Tool Support",
    "status": "ACTIVE",
    "accountId": "8a488489887a8d360188bdb6ed9c2a84",
    "account": {
        "id": "8a488489887a8d360188bdb6ed9c2a84",
        "name": "Health care services"
    },
    "configParameters": {
        "url": "https://UOGTTOS-TRUSTLOGIX-QA-ACCOUNT.snowflakecomputing.com/api/v2/databases/TLX_NEELAY_TEST/schemas/DEMO/mcp-servers/TESTMCP",
        "serverType": "SNOWFLAKE",
        "transport": "streamable-http",
        "authType": "key_pair",
        "account": "xy12345.us-east-1",
        "username": "MCP_SERVICE_USER",
        "privateKey": "****"
    },
    "denyByDefault": true,
    "protectionScope": "SERVER_ONLY",
    "resourceCount": 3,
    "resources": [
        {
            "id": "resource-sf-sql-exec-tool",
            "mcpServerId": "ff8080819cbbd623019cbbd6e2720002",
            "name": "sql_exec_tool",
            "description": "Standard SQL execution tool. Enforced via AST Rewrite.",
            "title": "SQL Execution Tool",
            "inputSchema": {
                "type": "object",
                "properties": {
                    "sql": {
                        "type": "string"
                    }
                }
            },
            "enforcementType": "BLOCK_OBJECT,INJECT_INSTRUCTIONS",
            "sensitiveInputArguments": "sql",
            attributes: [
                {"attributeType":"toolType","dataType":"STRING","values":["SQL"]}
            ]
        },
        {
            "id": "resource-sf-structured-data-fetcher",
            "mcpServerId": "ff8080819cbbd623019cbbd6e2720002",
            "name": "structured_data_fetcher",
            "description": "JSON-based query tool. Enforced via Deterministic Merge.",
            "title": "Structured Query Tool",
            "inputSchema": {
                "type": "object",
                "properties": {
                    "entity": {
                        "type": "string"
                    },
                    "attributes": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "filters": {
                        "type": "object"
                    }
                },
            },
            "enforcementType": "DETERMINISTIC_MERGE",
            "sensitiveInputArguments": "filters",
            attributes: [
                {"attributeType":"toolType","dataType":"STRING","values":["JSON"]}
            ]
            
        },
        {
            "id": "resource-sf-cortex-analyst-nl",
            "mcpServerId": "ff8080819cbbd623019cbbd6e2720002",
            "name": "cortex_analyst_nl",
            "description": "Natural language tool. Enforced via Prompt Rewrite.",
            "title": "Cortex NL Analyst",
            "inputSchema": {
                "type": "object",
                "properties": {
                    "query": {
                        "type": "string"
                    }
                }
            },
            "enforcementType": "PROMPT_REWRITE",
            "sensitiveInputArguments": "query",
            attributes: [
                {"attributeType":"toolType","dataType":"STRING","values":["Prompt"]}
            ]
        }
    ],


    "selectedTools": [
        {
            "name": "sql_exec_tool",
            "description": "Standard SQL execution tool. Enforced via AST Rewrite."
        },
        {
            "name": "structured_data_fetcher",
            "description": "JSON-based query tool. Enforced via Deterministic Merge."
        },
        {
            "name": "cortex_analyst_nl",
            "description": "Natural language tool. Enforced via Prompt Rewrite."
        }
    ],
    "serverRules": [
        {
            "attribute": {
                "id": "purpose",
                "name": "Purpose",
                "type": "Agent Attribute",
            },
            "operator": {
                "id": "equals",
                "name": "Equals"
            },
            "value": [
                {
                    "id": "Cost of Care Analysis",
                    "name": "Cost of Care Analysis",
                },
            ]
        }
    ],
    "toolRules": {
        "sql_exec_tool": [
            {
                "id": "cond_12",
                "attribute": {
                    "id": "GROUP",
                    "name": "Group",
                    "type": "User Attribute",
                },
                "operator": {
                    "id": "equals",
                    "name": "Equals"
                },
                "value": [
                    {
                        "id": "Patient Care",
                        "name": "Patient Care",
                    },
                    {
                        "id": "Research",
                        "name": "Research",
                    }
                ]            }
        ],
        "structured_data_fetcher": [
            {
                "id": "cond_13",
                "attribute": {
                    "id": "purpose",
                    "name": "Purpose",
                    "type": "Agent Attribute",
                },
                "operator": {
                    "id": "equals",
                    "name": "Equals"
                },
                "value": [
                    {
                        "id": "Sales",
                        "name": "Sales",
                    }
                ]
            }
        ],
        "cortex_analyst_nl": [
            {
                "id": "cond_14",
                "attribute": {
                    "id": "purpose",
                    "name": "Purpose",
                    "type": "Agent Attribute",
                },
                "operator": {
                    "id": "equals",
                    "name": "Equals"
                },
                "value": [
                    {
                        "id": "Product",
                        "name": "Product",
                    }
                ]
            }
        ]
    },
    "toolRuntime": {
        "sql_exec_tool": {
            "toolType": {
                "id": "SQL",
                "name": "SQL Query"
            }
        },
        "structured_data_fetcher": {
            "toolType": {
                "id": "JSON",
                "name": "JSON"
            }
        },
        "cortex_analyst_nl": {
            "toolType": {
                "id": "Prompt",
                "name": "Prompt"
            }
        }
    },
    "toolSelected": {
        "sql_exec_tool": true,
        "structured_data_fetcher": true,
        "cortex_analyst_nl": true
    }
},
    {
       "id": "ff8080819c907d1e019c91d2aa070003",
        "name": "Microsoft 365 MCP Server",
        "accountId": "ff8080819c907d1e019c91d2aa070003",
        "description": "Microsoft 365 Data Access Gateway",
        "status": "ACTIVE",
        "configParameters": {
            "url": "https://mcp.svc.cloud.microsoft.com/enterprise",
            "serverType": "MICROSOFT_365",
            "transport": "streamable-http",
            "authType": "oauth2"
        },
        "resourceCount": 1,
        "resources": [
            {
                "mcpServerId": "sf_mcp_001",
                "name": "get_opportunity_details",
                "description": "Fetch CRM opportunity data using structured parameters.",
                "title": "Microsoft 365 Data access tool",
                "inputSchema": {
                    "type": "object",
                    "properties": { "opportunity_id": { "type": "string" } }
                },
                "enforcementType": "PARAMETER_INJECTION",
                "sensitiveInputArguments": "opportunity_id"
            }
        ]
    },
    {
       "id": "ff8080819c907d1e019c91d2aa070004",
      "name": "Salesforce MCP Server",
        "accountId": "ff8080819c907d1e019c91d2aa070003",
        "description": "CRM Data Access Gateway",
        "status": "ACTIVE",
        "configParameters": {
            "url": "https://api.salesforce.com/platform/mcp/v1-beta.2/sandbox/platform/salesforce-api-context",
            "serverType": "SALESFORCE_SOBJECT_ALL",
            "transport": "streamable-http",
            "authType": "oauth2"
        },
        "resourceCount": 1,
        "resources": [
            {
                "mcpServerId": "sf_mcp_001",
                "name": "get_opportunity_details",
                "description": "Fetch CRM opportunity data using structured parameters.",
                "title": "SFDC Opportunity Tool",
                "inputSchema": {
                    "type": "object",
                    "properties": { "opportunity_id": { "type": "string" } }
                },
                "enforcementType": "PARAMETER_INJECTION",
                "sensitiveInputArguments": "opportunity_id"
            }
        ]
    },
    {
      "id": "ff8080819c907d1e019c91d2aa070005",
      "name": "ServiceNow MCP Server",
        "accountId": "ff8080819c907d1e019c91d2aa070003",
        "description": "ITSM Ticket and Audit Gateway",
        "status": "ACTIVE",
        "configParameters": {
            "url": "https://acme-inc.service-now.com/api/now/table/sys_mcp_server",
            "serverType": "SERVICENOW",
            "transport": "streamable-http",
            "authType": "basic"
        },
        "resourceCount": 1,
        "resources": [
            {
                "mcpServerId": "sn_mcp_002",
                "name": "fetch_incident_logs",
                "description": "Access system incident logs.",
                "title": "Incident Log Fetcher",
                "inputSchema": {
                    "type": "object",
                    "properties": { "incident_no": { "type": "string" } }
                },
                "enforcementType": "BLOCK_OBJECT",
                "sensitiveInputArguments": "incident_no"
            }
        ]
    },
    {
       "id": "ff8080819c907d1e019c91d2aa070006",
        "name": "CDATA SAP MCP Server",
        "accountId": "ff8080819c907d1e019c91d2aa070003",
        "description": "SAP ERP Connectivity via CDATA",
        "status": "ACTIVE",
        "configParameters": {
            "url": "https://sap-cdata-prod.cdata.com/mcp",
            "serverType": "SAP",
            "transport": "streamable-http",
            "authType": "key_pair"
        },
        "resourceCount": 1,
        "resources": [
            {
                "mcpServerId": "sap_mcp_003",
                "name": "sap_ledger_query",
                "description": "Query SAP Financial Ledgers. Opaque tool classification.",
                "title": "SAP Ledger Tool",
                "inputSchema": {
                    "type": "object",
                    "properties": { "opaque_query_string": { "type": "string" } }
                },
                "enforcementType": "ALLOW_DENY_ONLY",
                "sensitiveInputArguments": "opaque_query_string"
            }
        ]
    },
    {
       "id": "dbx_mcp_001",
        "name": "Databricks MCP Server",
        "accountId": "ff8080819c907d1e019c91d2cc090005",
        "description": "Databricks Managed MCP Server with Unity Catalog and Vector Search",
        "status": "ACTIVE",
        "configParameters": {
            "url": "https://adb-1234567890123456.7.azuredatabricks.net/api/2.0/mcp/unity-catalog/prod/warehouse",
            "serverType": "DATABRICKS",
            "transport": "streamable-http",
            "authType": "oauth_client_credentials",
            "tokenEndpoint": "https://adb-1234567890123456.7.azuredatabricks.net/oidc/v1/token",
            "scope": "all-apis"
        },
        "resourceCount": 2,
        "resources": [
            {
                "mcpServerId": "dbx_mcp_001",
                "name": "unity_catalog_query",
                "description": "Query Unity Catalog tables and schemas.",
                "title": "Unity Catalog Query Tool",
                "inputSchema": {
                    "type": "object",
                    "properties": {
                        "catalog": { "type": "string" },
                        "schema": { "type": "string" },
                        "query": { "type": "string" }
                    }
                },
                "enforcementType": "DETERMINISTIC_MERGE",
                "sensitiveInputArguments": "query"
            },
            {
                "mcpServerId": "dbx_mcp_001",
                "name": "vector_search_index",
                "description": "Query vector search indexes for similarity search.",
                "title": "Vector Search Tool",
                "inputSchema": {
                    "type": "object",
                    "properties": {
                        "indexName": { "type": "string" },
                        "queryVector": { "type": "array", "items": { "type": "number" } },
                        "topK": { "type": "integer" }
                    }
                },
                "enforcementType": "BLOCK_OBJECT",
                "sensitiveInputArguments": "queryVector"
            }
        ]
    }
] as unknown[]) as Application[];

export const mcpServerDiscovery: McpServerDiscoveryModel[] = [
  {
      "name": "TESTMCP",
      "url": "https://UOGTTOS-TRUSTLOGIX-QA-ACCOUNT.snowflakecomputing.com/api/v2/databases/TLX_NEELAY_TEST/schemas/DEMO/mcp-servers/TESTMCP",
      "serverType": "SNOWFLAKE",
      "authConfig": {
          "account": "UOGTTOS-TRUSTLOGIX-QA-ACCOUNT"
      }
  },
  {
      "name": "MY_DATA_ASSISTANT",
      "url": "https://UOGTTOS-TRUSTLOGIX-QA-ACCOUNT.snowflakecomputing.com/api/v2/databases/BRONZE/schemas/PURCHASE/mcp-servers/MY_DATA_ASSISTANT",
      "serverType": "SNOWFLAKE",
      "authConfig": {
          "account": "UOGTTOS-TRUSTLOGIX-QA-ACCOUNT"
      }
  }
]

// Reusing your conditionAttribute mappings for the UI builder
export const conditionAttributes: ConditionAttributeMappingModel[] = [
    {
        "name": "USER_ATTRIBUTE",
        "displayName": "User Attributes",
        "attributes": [
            {
                "dataType": { "name": "STRING", "elementType": "USER_ATTRIBUTE", "equivalentTypes": "STRING,TEXT" },
                "multiValue": false,
                "condition": { "id": "2", "name": "Equals", "description": "Equals" },
                "matchWithElement": [{ "name": "Constant Value", "valueType": "CONSTANT" }, { "name": "Agent Attribute", "valueType": "AGENT_ATTRIBUTE" }]
            }
            // ... (Additional mappings follow your established pattern)
        ]
    },
    {
        "name": "AGENT_ATTRIBUTE",
        "displayName": "Agent Attributes",
        "attributes": [
            {
                "dataType": { "name": "STRING", "elementType": "AGENT_ATTRIBUTE", "equivalentTypes": "STRING,TEXT" },
                "multiValue": false,
                "condition": { "id": "2", "name": "Equals", "description": "Equals" },
                "matchWithElement": [{ "name": "Constant Value", "valueType": "CONSTANT" }]
            }
        ]
    }
];

// Same shape as conditionAttributes; used by getConditionAttributesForApplicationUsingGet
export const conditionAttributesForApplication: ConditionAttributeMappingModel[] = conditionAttributes;

/** Mock column metadata for getColumnsUsingGet */
export const objectNames: ColumnMetadata[] = [
    { name: "EMAIL", type: "VARCHAR", schemaName: "PUBLIC", tableName: "USERS" },
    { name: "NAME", type: "VARCHAR", schemaName: "PUBLIC", tableName: "USERS" },
    { name: "CUSTOMER_ID", type: "NUMBER", schemaName: "PUBLIC", tableName: "ORDERS" },
];

export const userAttributes = {
    "entitlementColumns": [
        { "displayName": "Department", "name": "DEPARTMENT", "type": "STRING" },
        { "displayName": "Clearance", "name": "CLEARANCE_LEVEL", "type": "NUMBER" },
        { "displayName": "Region", "name": "REGION", "type": "STRING" },
        { "displayName": "Group", "name": "GROUP", "type": "STRING" }
    ]
};

export const agentAttributes = [
    { "name": "purpose", "displayName": "Purpose", "dataType": "STRING", "value": ["Cost of Care Analysis", "Medical Analysis"], "type": "SYSTEM"},
    { "name": "trust_tier", "displayName": "Intent", "dataType": "STRING", "value": ["Summarize", "Analyze"], "type": "SYSTEM"}
];


export const accessPolicies = {
    "items": [
        {
            "id": "ff8080819d1bca68019d21f887db00d5",
            "name": "mcp_tool_access_policy_tet_mcp_sql_exec_tool",
            "policyDataTypeId": "10",
            "policyDataTypeName": "Row Filter",
            "description": "Tool access policy for sql_exec_tool",
            "createdDate": "2026-03-24T22:30:29.088+0000",
            "lastModifiedDate": "2026-03-25T17:33:51.143+0000",
            "deleted": false,
            "createdBy": "dev@khakurel.com",
            "lastModifiedBy": "dev@khakurel.com",
            "rules": [
                {
                    "queryContextValue": "Everyone",
                    "columnRules": [
                        {
                            "unProtect": false,
                            "columnRules": [
                                {
                                    "value": "Patient Care",
                                    "unProtect": false,
                                    "elementName": "GROUP",
                                    "elementDataType": "VARCHAR(16777216)",
                                    "columnRules": [],
                                    "functionArguments": "{}",
                                    "arguments": {},
                                    "conditionId": "2",
                                    "conditionName": "Equals",
                                    "conjunction": "OR",
                                    "elementType": "USER_ATTRIBUTE",
                                    "valueType": "CONSTANT",
                                    "ruleSequenceNumber": 1
                                },
                                {
                                    "value": "Research",
                                    "unProtect": false,
                                    "elementName": "GROUP",
                                    "elementDataType": "VARCHAR(16777216)",
                                    "columnRules": [],
                                    "functionArguments": "{}",
                                    "arguments": {},
                                    "conditionId": "2",
                                    "conditionName": "Equals",
                                    "conjunction": "OR",
                                    "elementType": "USER_ATTRIBUTE",
                                    "valueType": "CONSTANT",
                                    "ruleSequenceNumber": 2
                                }
                            ],
                            "arguments": {},
                            "conjunction": "OR",
                            "ruleSequenceNumber": 1
                        }
                    ],
                    "columnGrants": [],
                    "queryContextId": "8",
                    "queryContextName": "Everyone"
                }
            ],
            "databaseObjects": [],
            "objectNameList": [
                "sql_exec_tool"
            ],
            "enabled": false,
            "status": "POLICY_DEPLOYED",
            "enableFutureGrants": false,
            "enableRiskBasedAccess": false,
            "privilegeList": [],
            "policySubtype": "OBJECT_NAMES",
            "version": 1,
            "policyActions": [
                {
                    "id": "1",
                    "actionName": "REDEPLOY",
                    "actionDisplayName": "Redeploy",
                    "disabled": false
                },
                {
                    "id": "3",
                    "actionName": "DISABLE",
                    "actionDisplayName": "Disable",
                    "disabled": false
                },
                {
                    "id": "12",
                    "actionName": "RENAME",
                    "actionDisplayName": "Rename Policy",
                    "disabled": false
                },
                {
                    "id": "8",
                    "actionName": "EDIT_DRAFT",
                    "actionDisplayName": "Edit Draft",
                    "disabled": false
                },
                {
                    "id": "6",
                    "actionName": "DELETE",
                    "actionDisplayName": "Delete",
                    "disabled": false
                }
            ],
            "draftPolicyId": "402881139d25760e019d260f508f0024",
            "includeViewAccessGrants": false,
            "evaluationResult": {
                "actions": [],
                "entitlementsAttributes": [],
                "resourceAttributes": [],
                "context": {}
            },
            "resourceMetadata": {
                "id": "ff8080819d1bca68019d21f8849b00cb",
                "objectType": "Tool",
                "objectNames": [
                    "sql_exec_tool"
                ],
                "resourceIdList": [
                    {
                        "id": "ff8080819d1bca68019d21f8849b00cb",
                        "name": "sql_exec_tool"
                    }
                ]
            },
            "resourceSourceType": "RESOURCE",
            "policyOwner": true,
            "enableRedeployFromDeltaSync": false,
            "redeployRequired": false
        },
        {
            "id": "ff8080819d1bca68019d21f887db00d6",
            "name": "mcp_tool_access_policy_tet_mcp_structured_data_fetcher",
            "policyDataTypeId": "10",
            "policyDataTypeName": "Row Filter",
            "description": "Tool access policy for structured_data_fetcher",
            "createdDate": "2026-03-24T22:30:29.088+0000",
            "lastModifiedDate": "2026-03-25T17:33:51.143+0000",
            "deleted": false,
            "createdBy": "dev@khakurel.com",
            "lastModifiedBy": "dev@khakurel.com",
            "rules": [
                {
                    "queryContextValue": "Everyone",
                    "columnRules": [
                        {
                            "unProtect": false,
                            "columnRules": [
                                {
                                    "value": "Patient Care",
                                    "unProtect": false,
                                    "elementName": "GROUP",
                                    "elementDataType": "VARCHAR(16777216)",
                                    "columnRules": [],
                                    "functionArguments": "{}",
                                    "arguments": {},
                                    "conditionId": "2",
                                    "conditionName": "Equals",
                                    "conjunction": "OR",
                                    "elementType": "USER_ATTRIBUTE",
                                    "valueType": "CONSTANT",
                                    "ruleSequenceNumber": 1
                                },
                                {
                                    "value": "Research",
                                    "unProtect": false,
                                    "elementName": "GROUP",
                                    "elementDataType": "VARCHAR(16777216)",
                                    "columnRules": [],
                                    "functionArguments": "{}",
                                    "arguments": {},
                                    "conditionId": "2",
                                    "conditionName": "Equals",
                                    "conjunction": "OR",
                                    "elementType": "USER_ATTRIBUTE",
                                    "valueType": "CONSTANT",
                                    "ruleSequenceNumber": 2
                                }
                            ],
                            "arguments": {},
                            "conjunction": "OR",
                            "ruleSequenceNumber": 1
                        }
                    ],
                    "columnGrants": [],
                    "queryContextId": "8",
                    "queryContextName": "Everyone"
                }
            ],
            "databaseObjects": [],
            "objectNameList": [
                "structured_data_fetcher"
            ],
            "enabled": false,
            "status": "POLICY_DEPLOYED",
            "enableFutureGrants": false,
            "enableRiskBasedAccess": false,
            "privilegeList": [],
            "policySubtype": "OBJECT_NAMES",
            "version": 1,
            "policyActions": [
                {
                    "id": "1",
                    "actionName": "REDEPLOY",
                    "actionDisplayName": "Redeploy",
                    "disabled": false
                },
                {
                    "id": "3",
                    "actionName": "DISABLE",
                    "actionDisplayName": "Disable",
                    "disabled": false
                },
                {
                    "id": "12",
                    "actionName": "RENAME",
                    "actionDisplayName": "Rename Policy",
                    "disabled": false
                },
                {
                    "id": "8",
                    "actionName": "EDIT_DRAFT",
                    "actionDisplayName": "Edit Draft",
                    "disabled": false
                },
                {
                    "id": "6",
                    "actionName": "DELETE",
                    "actionDisplayName": "Delete",
                    "disabled": false
                }
            ],
            "draftPolicyId": "402881139d25760e019d260f508f0024",
            "includeViewAccessGrants": false,
            "evaluationResult": {
                "actions": [],
                "entitlementsAttributes": [],
                "resourceAttributes": [],
                "context": {}
            },
            "resourceMetadata": {
                "id": "ff8080819d1bca68019d21f8849b00cb",
                "objectType": "Tool",
                "objectNames": [
                    "structured_data_fetcher"
                ],
                "resourceIdList": [
                    {
                        "id": "ff8080819d1bca68019d21f8849b00cb",
                        "name": "structured_data_fetcher"
                    }
                ]
            },
            "resourceSourceType": "RESOURCE",
            "policyOwner": true,
            "enableRedeployFromDeltaSync": false,
            "redeployRequired": false
        },
        {
            "id": "ff8080819d1bca68019d21f887db00d7",
            "name": "mcp_tool_access_policy_tet_mcp_cortex_analyst_nl",
            "policyDataTypeId": "10",
            "policyDataTypeName": "Row Filter",
            "description": "Tool access policy for cortex_analyst_nl",
            "createdDate": "2026-03-24T22:30:29.088+0000",
            "lastModifiedDate": "2026-03-25T17:33:51.143+0000",
            "deleted": false,
            "createdBy": "dev@khakurel.com",
            "lastModifiedBy": "dev@khakurel.com",
            "rules": [
                {
                    "queryContextValue": "Everyone",
                    "columnRules": [
                        {
                            "unProtect": false,
                            "columnRules": [
                                {
                                    "value": "Patient Care",
                                    "unProtect": false,
                                    "elementName": "GROUP",
                                    "elementDataType": "VARCHAR(16777216)",
                                    "columnRules": [],
                                    "functionArguments": "{}",
                                    "arguments": {},
                                    "conditionId": "2",
                                    "conditionName": "Equals",
                                    "conjunction": "OR",
                                    "elementType": "USER_ATTRIBUTE",
                                    "valueType": "CONSTANT",
                                    "ruleSequenceNumber": 1
                                },
                                {
                                    "value": "Research",
                                    "unProtect": false,
                                    "elementName": "GROUP",
                                    "elementDataType": "VARCHAR(16777216)",
                                    "columnRules": [],
                                    "functionArguments": "{}",
                                    "arguments": {},
                                    "conditionId": "2",
                                    "conditionName": "Equals",
                                    "conjunction": "OR",
                                    "elementType": "USER_ATTRIBUTE",
                                    "valueType": "CONSTANT",
                                    "ruleSequenceNumber": 2
                                }
                            ],
                            "arguments": {},
                            "conjunction": "OR",
                            "ruleSequenceNumber": 1
                        }
                    ],
                    "columnGrants": [],
                    "queryContextId": "8",
                    "queryContextName": "Everyone"
                }
            ],
            "databaseObjects": [],
            "objectNameList": [
                "cortex_analyst_nl"
            ],
            "enabled": false,
            "status": "POLICY_DEPLOYED",
            "enableFutureGrants": false,
            "enableRiskBasedAccess": false,
            "privilegeList": [],
            "policySubtype": "OBJECT_NAMES",
            "version": 1,
            "policyActions": [
                {
                    "id": "1",
                    "actionName": "REDEPLOY",
                    "actionDisplayName": "Redeploy",
                    "disabled": false
                },
                {
                    "id": "3",
                    "actionName": "DISABLE",
                    "actionDisplayName": "Disable",
                    "disabled": false
                },
                {
                    "id": "12",
                    "actionName": "RENAME",
                    "actionDisplayName": "Rename Policy",
                    "disabled": false
                },
                {
                    "id": "8",
                    "actionName": "EDIT_DRAFT",
                    "actionDisplayName": "Edit Draft",
                    "disabled": false
                },
                {
                    "id": "6",
                    "actionName": "DELETE",
                    "actionDisplayName": "Delete",
                    "disabled": false
                }
            ],
            "draftPolicyId": "402881139d25760e019d260f508f0024",
            "includeViewAccessGrants": false,
            "evaluationResult": {
                "actions": [],
                "entitlementsAttributes": [],
                "resourceAttributes": [],
                "context": {}
            },
            "resourceMetadata": {
                "id": "ff8080819d1bca68019d21f8849b00cb",
                "objectType": "Tool",
                "objectNames": [
                    "cortex_analyst_nl"
                ],
                "resourceIdList": [
                    {
                        "id": "ff8080819d1bca68019d21f8849b00cb",
                        "name": "cortex_analyst_nl"
                    }
                ]
            },
            "resourceSourceType": "RESOURCE",
            "policyOwner": true,
            "enableRedeployFromDeltaSync": false,
            "redeployRequired": false
        },
        //cortex_analyst_nl
        {
            "id": "ff8080819d1bca68019d21f8875f00d0",
            "name": "mcp_server_access_policy_tet_mcp",
            "policyDataTypeId": "10",
            "policyDataTypeName": "Row Filter",
            "description": "Server access policy for tet mcp",
            "createdDate": "2026-03-24T22:30:28.967+0000",
            "lastModifiedDate": "2026-03-25T17:33:51.070+0000",
            "deleted": false,
            "createdBy": "dev@khakurel.com",
            "lastModifiedBy": "dev@khakurel.com",
            "rules": [
                {
                    "queryContextValue": "Everyone",
                    "columnRules": [
                        {
                            "unProtect": false,
                            "columnRules": [
                                {
                                    "value": "Research Analysis,Clinical Analysis",
                                    "unProtect": false,
                                    "elementName": "purpose",
                                    "elementDataType": "VARCHAR(16777216)",
                                    "columnRules": [],
                                    "functionArguments": "{}",
                                    "arguments": {},
                                    "conditionId": "2",
                                    "conditionName": "Equals",
                                    "conjunction": "OR",
                                    "elementType": "AGENT_ATTRIBUTE",
                                    "valueType": "CONSTANT",
                                    "ruleSequenceNumber": 1
                                }
                            ],
                            "arguments": {},
                            "conjunction": "OR",
                            "ruleSequenceNumber": 1
                        }
                    ],
                    "columnGrants": [],
                    "queryContextId": "8",
                    "queryContextName": "Everyone"
                }
            ],
            "databaseObjects": [],
            "objectNameList": [],
            "enabled": false,
            "status": "POLICY_DEPLOYED",
            "enableFutureGrants": false,
            "enableRiskBasedAccess": false,
            "privilegeList": [],
            "policySubtype": "OBJECT_NAMES",
            "version": 1,
            "policyActions": [
                {
                    "id": "1",
                    "actionName": "REDEPLOY",
                    "actionDisplayName": "Redeploy",
                    "disabled": false
                },
                {
                    "id": "3",
                    "actionName": "DISABLE",
                    "actionDisplayName": "Disable",
                    "disabled": false
                },
                {
                    "id": "12",
                    "actionName": "RENAME",
                    "actionDisplayName": "Rename Policy",
                    "disabled": false
                },
                {
                    "id": "8",
                    "actionName": "EDIT_DRAFT",
                    "actionDisplayName": "Edit Draft",
                    "disabled": false
                },
                {
                    "id": "6",
                    "actionName": "DELETE",
                    "actionDisplayName": "Delete",
                    "disabled": false
                }
            ],
            "draftPolicyId": "402881139d25760e019d260f500a001f",
            "includeViewAccessGrants": false,
            "evaluationResult": {
                "actions": [],
                "entitlementsAttributes": [],
                "resourceAttributes": [],
                "context": {}
            },
            "resourceSourceType": "APPLICATION",
            "policyOwner": true,
            "enableRedeployFromDeltaSync": false,
            "redeployRequired": false
        }
    ],
    "total": 2,
    "pageNo": 1,
    "pageSize": 20
}
/**
 * Condition builder config for MCP user-access rules.
 * Attributes represent common user identity dimensions that control
 * who can call the MCP server or individual tools.
 */
export const MCP_RULES_CONFIG: ConditionBuilderConfig = {
  attributeGroupField: "type",
  attributes: [
    {
      id: "GROUP",
      name: "Group",
      type: "User Attribute",
      valueType: "single-select",
      valueOptions: [
        { id: "HR", name: "HR" },
        { id: "IT", name: "IT" },
        { id: "Finance", name: "Finance" },
        { id: "Patient Care", name: "Patient Care" },
        { id: "Research", name: "Research" },
        { id: "Clinical", name: "Clinical" },
      ],
    },
    {
      id: "ROLE",
      name: "Role",
      type: "User Attribute",
      valueType: "single-select",
      valueOptions: [
        { id: "READER", name: "Data Reader" },
        { id: "WRITER", name: "Data Writer" },
        { id: "ADMIN", name: "Data Admin" },
      ],
    },
    {
      id: "purpose",
      name: "Purpose",
      type: "Agent Attribute",
      valueType: "multi-select",
      valueOptions: [
        { id: "Financial Audit", name: "Financial Audit" },
        { id: "Cost of Care Analysis", name: "Cost of Care Analysis" },
        { id: "Medical Analysis", name: "Medical Analysis" },
        { id: "Research Analysis", name: "Research Analysis" },
        { id: "Clinical Analysis", name: "Clinical Analysis" },
        { id: "Patient Care Analysis", name: "Patient Care Analysis" },
      ],
    },
    {
      id: "intent",
      name: "Intent",
      type: "Agent Attribute",
      valueType: "multi-select",
      valueOptions: [
        { id: "Product", name: "Product Analysis" },
        { id: "Marketing", name: "Marketing Analysis" },
        { id: "Sales", name: "Sales Analysis" },
        { id: "Engineering", name: "Engineering Analysis" },
        { id: "Customer Support", name: "Customer Support Analysis" },
      ],
    }
  ],
  operators: [
    { id: "equals", name: "Equals" },
    { id: "not_equals", name: "Not Equals" },
    { id: "contains", name: "Contains" },
    { id: "starts_with", name: "Starts With" },
  ],
  allowNestedConditions: true,
  // resolveOperator: (attributeId: string, operatorId: string) => {
  //   if (operatorId === "intention" && attributeId === "purpose") {
  //     return Promise.resolve({
  //       valueType: "text-area",
  //       valueOptions: [{ id: "Product", name: "Product" }],
  //     });
  //   }
  // },
};

